interface RawSVGImageProps {
  svg: string;
  className?: string;
}

export const RawSVGImage = ({ svg, className }: RawSVGImageProps) => {
  const base64SVG = btoa(svg);
  return <img className={className} src={`data:image/svg+xml;base64,${base64SVG}`} alt="Raw SVG" />;
};
